import { MICROSERVICE_CONFIG } from "../../config/configs";
import { authenticatedApi } from "../api";

export const getAllPromotions = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/promotions${
			payload ? `?${payload}` : ""
		}`
	);
	return response.data;
};

export const getPromotionById = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/promotions/${id}`
	);
	return response.data;
};

export const addPromotion = async (payload) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/promotions`,
		payload
	);
	return response.data;
};

export const updatePromotion = async (payload) => {
	const { id, body } = payload;
	const response = await authenticatedApi.put(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/promotions/${id}`,
		body
	);
	return response.data;
};

export const sendPromotion = async (id) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/promotions/${id}/send`
	);
	return response.data;
};

export const deletePromotionById = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/promotions/${id}`
	);
	return response.data;
};
